<div class="row form">
  <div class="col-lg-12 m-t-10">
    <div class="row">
      <div class="col-12">
        <form id="paid_form" validate [formGroup]="item" class="row sale__form">
          <div id="boxProduct" class="col-lg-7 boxProduct">
            <div class="card sale__product__header">
              <div class="card-body p-10">
                <div class="row">
                  <!-- <div class="col-lg-1">
                    <button class="btn btn-dark f-s-11"><i class="fas fa-undo"></i></button>
                  </div> -->
                  <div class="col-lg-8 p-l-0">
                    <div class="input-group w-100">
                      <div class="input-group-prepend b-0 w-12">
                        <div class="input-group-text w-100 text-center bg-default text-dark pointer"
                          (click)="resetSearchProducts()">
                          <i class="fas fa-broom w-100"></i>
                        </div>
                      </div>
                      <input type="text" class="form-control" id="searchProducts" (keyup)="debouncedSearch($event)"
                        [(ngModel)]="textSearchProduct" [ngModelOptions]="{standalone: true}" #searchInputProduct />
                      <!-- <div class="input-group-append bg-custom b-0 w-12">
                        <div class="input-group-text w-100 text-center"><i class="fa fa-search w-100"></i></div>
                      </div> -->
                    </div>
                  </div>
                  <div class="col-lg-4 p-l-0">
                    <select class="form-control" id="warehousesSelected" (change)="changeWarehouseSelected()">
                      <option *ngFor="let item of warehouses" [value]="item.id">{{ item.description }}</option>
                    </select>
                  </div>
                  <!-- <div class="col-lg-2">
                    <div class="input-group-append bg-custom b-0 pointer">
                      <span class="input-group-text p-t-3 p-b-3">
                        <div class="custom-control custom-checkbox" style="padding-left: 1.2rem;">
                          <input class="custom-control-input" type="checkbox" id="is_barcode" wire:model="isbarcode">
                          <label class="custom-control-label p-t-3 f-s-14" for="is_barcode">
                            <i class="fas fa-barcode"></i>
                          </label>
                        </div>
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-4 p-l-0">
                  </div> -->
                </div>
              </div>
            </div>
            <div class="sale__product__body">
              <div class="row sale__product__body__rowItem">
                <ng-container *ngIf="products.length == 0">
                  <div class="col-12">
                    <p class="f-s-13 m-b-0">No se encontraron items</p>
                  </div>
                </ng-container>
                <ng-container *ngIf="products.length > 0">
                  <div class="col-lg-3 col-6 sale__product__body__parentItem"
                    *ngFor="let product of products | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let index_ = index">
                    <div class="sale__product__body__item" (click)="addProduct(product)">
                      <div class="sale__product__body__item__boxImg">
                        <ng-container *ngIf="product.is_control_stock">
                          <div *ngFor="let stock of product.productstock">
                            <ng-container *ngIf="stock.warehouse_id == warehousesSelected.id">
                              <p class="sale__product__body__item__boxImg__stock"> {{stock.stock}}{{stock.unitprefix}}
                              </p>
                              <p *ngIf="stock.stock == 0" class="sale__product__body__item__boxImg__notStock">NO TIENE
                                STOCK</p>
                            </ng-container>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="!product.is_control_stock">
                          <span class="sale__product__body__item__boxImg__notcontrolstock">SIN CONTROL
                            STOCK</span>
                        </ng-container>
                        <ng-container *ngIf="product.url_image != null">
                          <img class="sale__product__body__item__boxImg__img" src="tenants/{{product.url_image}}">
                        </ng-container>
                        <ng-container *ngIf="product.url_image == null">
                          <img class="sale__product__body__item__boxImg__img" src="/images/default.png">
                        </ng-container>
                      </div>
                      <div class="sale__product__body__item__boxText">
                        <div class="sale__product__body__item__boxText__boxName">
                          <p class="sale__product__body__item__boxText__name">
                            {{product.description}}
                          </p>
                        </div>
                        <ng-container *ngIf="product.typeprice_id == typeprice_general">
                          <p class="sale__product__body__item__boxText__price text-primary">
                            {{toolsService.momeySol()}}{{product.price_sale}}
                          </p>
                        </ng-container>
                        <ng-container *ngIf="product.typeprice_id == typeprice_unit">
                          <p class="sale__product__body__item__boxText__priceunit text-dark">
                            <span>{{toolsService.momeySol()}} Por Medidas</span>
                          </p>
                        </ng-container>
                        <ng-container *ngIf="product.is_favorite">
                          <i class="sale__product__body__item__boxText__favorite fas fa-star color-favorite"></i>
                        </ng-container>
                      </div>
                    </div>
                    <ng-container *ngIf="product.typeprice_id == typeprice_unit">
                      <span class="sale__product__body__item__boxText__infopriceunit" data-toggle="modal"
                        data-target="#openExtendsProductPriceUnit"
                        (click)="ProductPriceunitsExtendsComponent.getDataProduct(product)">
                        <i class="fas fa-info"></i>
                      </span>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
              <div class="sale__emptyBox" *ngIf="products.length == 0">
                <i class="fas fa-clipboard-list f-s-70"></i>
                <p class="m-t-15 f-s-20">Lista de productos</p>
              </div>
            </div>
            <div class="m-t-10 sale__product__body__boxpagination" *ngIf="exist_favorites">
              <div class="row content_pagination">
                <div class="col-lg-4">
                  <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.
                  </p>
                </div>
                <div class="text-right col-lg-8">
                  <ng-container *ngIf="products.length > 0">
                    <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <div id="boxDetail" class="col-lg-5 boxDetail sale__detail">
            <div class="flex flex-100 sale__detail__title p-l-0 p-r-0">
              <div class="flex-30 text-capitalize">
                <span class="text-capitalize f-s-13">{{date_sale | date: 'mediumDate'}}</span>
              </div>
              <div class="flex-70 text-right">
                <ng-container *ngIf="isHotel">
                  <button *ngIf="hotelBookingSelected == null" type="button"
                    class="btn btn-sm btn-outline-secondary m-r-5" data-toggle="modal"
                    data-target="#openExtendsHotelbookings" (click)="HotelbookingsExtendsComponent.init()">
                    <i class="fas fa-list-alt m-r-3"></i>Reserva hotel
                  </button>
                  <ng-container *ngIf="hotelBookingSelected != null">
                    <div style="padding: 8px 25px 8px; background: rgb(238, 238, 238); border-radius: 5px;">
                      <!-- <div>
                        <span
                          class="badge badge badge-{{hotelBookingSelected.status_class}}">{{hotelBookingSelected.checkin_status}}</span>
                      </div> -->
                      <div class="f-s-12">
                        <span
                          class="badge badge badge-{{hotelBookingSelected.status_class}} f-s-12 m-r-5">RESERVA:</span>
                        <span class="bold">{{hotelBookingSelected.roomtype.description}} -
                          {{hotelBookingSelected.bedroom.code_number}}</span>
                        <span class="m-l-2"><i class="fas fa-user-alt m-l-2"></i></span>
                        {{hotelBookingSelected.booking_data.client_data.fullname}}
                        <span class="pointer" (click)="removeBookHotel()" style="position: absolute; right: 18px">
                          <i class="fas far fa-trash-alt f-s-12 text-danger"></i>
                        </span>
                      </div>

                    </div>
                  </ng-container>



                </ng-container>
                <!-- @if($order == null and $proforma == null)
                        <button type="button" class="btn btn-sm btn-outline-secondary m-r-5" wire:click="openExtendsProformaList">
                            <i class="fas fa-list-alt m-r-2"></i>Proformas
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-success" wire:click="openExtendsOrderList">
                            <i class="fas fa-search m-r-2"></i>Pedidos
                        </button>
                    @else
                        @if($order != null)
                            <button type="button" class="btn btn-sm btn-outline-danger m-r-5"
                                title="Quitar pedido seleccionado"
                                wire:click="removerOrderSelected">
                                <i class="far fa-trash-alt m-r-2"></i>
                            </button>
                            <span class="badge badge-primary f-s-12 m-r-10">
                                N° PEDIDO : <span class="bold">{{$order->code}}</span>
                            </span>
                        @endif
                        @if($proforma != null)
                            <button type="button" class="btn btn-sm btn-outline-danger m-r-5"
                                title="Quitar proforma seleccionado"
                                wire:click="removeProformaSelected">
                                <i class="far fa-trash-alt m-r-2"></i>
                            </button>
                            <span class="badge badge-primary f-s-12 m-r-10">
                                N° PROFORMA : <span class="bold">{{$proforma->nro_voucher}}</span>
                            </span>
                        @endif
                    @endif -->

              </div>
            </div>
            <div class="sale__detail__body">
              <div>
                <div class="flex flex-100 sale__detail__body__head">
                  <div class="flex-5"></div>
                  <div class="flex-45">
                    Descripción <i class="fas fa-cart-arrow-down m-r-5 m-l-10"></i>({{details.length}})
                  </div>
                  <div class="flex-20 text-center">
                    Cant.
                  </div>
                  <div class="flex-30 text-center">
                    SubTotal
                  </div>
                </div>
                <div class="sale__detail__body__content">
                  <ng-container *ngIf="details.length > 0">
                    <div class="accordion">
                      <ng-container *ngFor="let detail of details ; let index_ = index">
                        <div class="accordion-item">
                          <div class="accordion-titel accordion-box{{detail.id}}">
                            <div class="flex flex-100 sale__detail__body__item flex-wrap">
                              <div class="flex flex-100 p-0">
                                <div class="flex-5 sale__detail__body__item__boxTrash flex-wrap p-t-2">
                                  <i class="far fa-trash-alt f-s-14 p-t-2" (click)="removeProduct(index_)"></i>
                                </div>
                                <div class="flex-45 content-description-product" (click)="openAccordion(detail.id)">
                                  <p class="sale__detail__body__item__name">
                                    <span class="completeDescription cursor-zoom-in" data-toggle="tooltip"
                                      data-placement="right" title="{{detail.description}}">
                                      <i class="fas fa-info-circle m-r-2"></i>
                                    </span>
                                    {{detail.description}}
                                  </p>
                                  <ng-container *ngIf="detail.typeprice_id == typeprice_general">
                                    <span class="badge badge-light f-s-9">P.G </span>
                                  </ng-container>
                                  <ng-container *ngIf="detail.typeprice_id == typeprice_unit">
                                    <span class="badge badge-dark f-s-9">Px UM</span>
                                    <ng-container *ngFor="let unit of detail.unitsmeasure">
                                      <ng-container *ngIf="detail.unit_id == unit.id">
                                        <span class="f-s-9">({{unit.description}})</span>
                                      </ng-container>
                                    </ng-container>
                                  </ng-container>
                                </div>
                                <div class="flex-20">
                                  <!-- <input type="text" id="quantity{{index_}}" value="{{detail.quantity}}"
                                    (keyup)="changeQuantity($event.target, index_)" numeric decimals="2"
                                    onclick="click_input(this)" class="form-control form-control-sm text-center bold"
                                    required> -->
                                  <div class="quantity-box">
                                    <button type="button" class="btn-minus"
                                      (click)="changeQuantityByButton(-1, index_)">−</button>
                                    <input type="text" id="quantity{{index_}}" value="{{detail.quantity}}"
                                      (keyup)="changeQuantity($event.target, index_)" numeric decimals="2"
                                      class="form-control form-control-sm text-center bold" onclick="click_input(this)"
                                      required>
                                    <button type="button" class="btn-plus"
                                      (click)="changeQuantityByButton(1, index_)">+</button>
                                  </div>
                                </div>
                                <div class="flex-30 p-l-5 p-r-5">
                                  <div class="input-group">
                                    <div class="input-group-prepend">
                                      <span class="input-group-text bold">{{toolsService.momeySol()}}</span>
                                    </div>
                                    <input value="{{detail.subtotal}}"
                                      class="form-control form-control-sm text-right bold" id="subtotal{{index_}}"
                                      type="text" disabled>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="accordion-contant">
                            <div class="flex flex-100 p-t-5 p-b-0">
                              <div class="flex-5">
                                <i class="fas fa-search-plus f-s-15 pointer text-success m-t-8" data-toggle="modal"
                                  data-target="#openExtendsProductInformationdetail"
                                  (click)="ProductInformationdetailExtendsComponent.getDataProduct(detail)"></i>
                              </div>
                              <div class="flex-40 text-left p-r-15">
                                <select class="form-control form-control-sm" id="unitSelected{{index_}}"
                                  (change)="changeUnitSelected($event.target,index_, detail)">
                                  <ng-container *ngFor="let unit of detail.unitsmeasure">
                                    <ng-container *ngIf="detail.unit_id == unit.id">
                                      <option value="{{unit.id}}" selected="true">
                                        {{unit.description}} ({{unit.equivalence}})</option>
                                    </ng-container>
                                    <ng-container *ngIf="detail.unit_id != unit.id">
                                      <option value="{{unit.id}}">
                                        {{unit.description}} ({{unit.equivalence}})</option>
                                    </ng-container>
                                  </ng-container>
                                </select>
                              </div>
                              <div class="flex flex-25 p-0">
                                <div class="flex-100 text-left">
                                  <ng-container *ngIf="detail.is_control_stock">
                                    <p class="text-dark f-s-11 m-b-0 m-t-5">
                                      <span class="light">Stock:</span>
                                      <span *ngFor="let stock of detail.productstock">
                                        <ng-container *ngIf="stock.warehouse_id == warehousesSelected.id">
                                          {{stock.stock}} {{stock.unitprefix}}
                                        </ng-container>
                                      </span>
                                    </p>
                                  </ng-container>
                                </div>
                              </div>
                              <div class="flex-30 text-center">
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span class="input-group-text bold">Precio</span>
                                  </div>
                                  <input type="text" id="price{{index_}}" value="{{detail.price}}"
                                    (keyup)="changePrice($event.target, index_)" numeric decimals="2"
                                    onclick="click_input(this)" class="form-control form-control-sm text-right"
                                    required="true">
                                </div>
                              </div>
                            </div>
                            <!-- <div class="flex flex-100 p-t-5 p-b-0">
                                    <div class="flex-80 text-left p-r-15 m-t-10">
                                      <div class="input-group">
                                        <div class="input-group-prepend input-group-sm" wire:ignore.self>
                                          <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" id="is_renewal{{$loop->index}}"
                                              x-on:change="changeDateRenewal('{{$loop->index}}')">
                                            <label class="custom-control-label p-t-3" for="is_renewal{{$loop->index}}">
                                              <span class="f-s-10 m-r-10">¿Recordar renovación?</span>
                                            </label>
                                          </div>
                                        </div>
                                        <input disabled type="text" class="form-control form-control-sm"
                                          id="date_renewal{{$loop->index}}">
                                      </div>
                                    </div>
                                  </div> -->
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="details.length == 0">
                    <div class="sale__detail__body__itemEmpty">
                      <i class="fas fa-shopping-basket f-s-50"></i>
                      <p class="f-s-14 m-t-10">Debe seleccionar al menos un producto</p>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="sale__detail__summary">
              <div class="row sale__detail__summary__item">
                <div class="col-lg-6">
                  Subtotal
                </div>
                <div class="col-lg-6">
                  {{toolsService.momeySol()}} {{subtotal}}
                </div>
              </div>

              <div class="row sale__detail__summary__item">
                <div class="col-lg-6">
                  IGV
                  <ng-container *ngIf="igvSelected != null">
                    ({{igvSelected.percentage}} %)
                  </ng-container>

                </div>
                <div class="col-lg-6">
                  {{toolsService.momeySol()}}{{total_igv}}
                </div>
              </div>
              <div class="row sale__detail__summary__total">
                <div class="col-lg-6">
                  <span class="text-primary sale__detail__summary__total__txt">TOTAL</span>
                </div>
                <div class="col-lg-6">
                  <span class="text-primary sale__detail__summary__total__number">
                    {{toolsService.momeySol()}} {{total_sale}}
                  </span>
                </div>
              </div>
            </div>
            <div class="sale__detail__footer btnsBoxDetail">
              <div class="flex flex-100 p-0">
                <div class="flex-20">
                  <button type="button" class="btn btn-outline-danger btn-lg w-100" (click)="cleanSale()">
                    Cancelar
                  </button>
                </div>
                <div class="flex flex-80 p-t-0 p-b-0 p-l-10">
                  <!-- <button type="button" class="btn btn-success btn-lg flex-40" ng-disabled="true">
                    Guardar Venta <i class="far fa-save m-l-5"></i>
                  </button> -->
                  <button type="button" *ngIf="hotelBookingSelected == null"
                    class="btn btn-secondary btn-lg flex-60 m-l-10" (click)="changeToPaid()" [disabled]="total_sale==0">
                    Continuar a pagar <i class="fas fa-arrow-right m-l-5"></i>
                  </button>
                  <button *ngIf="hotelBookingSelected != null" type="button" class="btn btn-checkin btn-lg flex-100"
                    ng-disabled="total_sale == 0" (click)="saveHotelBooking()">
                    Agregar a Reserva de hotel <i class="fas fa-hotel m-l-3"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div id="boxPaid" class="col-lg-7 boxPaid p-0">
            <div class="flex flex-100 sale__detail__title bg-white justify-center m-b-15 f-s-16">
              <div class="flex-50">
              </div>
              <div class="flex-50 text-right">
                <span class="text-primary bold text-uppercase"><i class="far fa-money-bill-alt m-r-5"></i>
                  Detalle de pago</span>
              </div>
            </div>
            <div class="col-12 contentDetailPaid">
              <div class="row">
                <div class="form-group col-lg-4">
                  <label>Tipo de venta<span class="required"></span></label>
                  <select class="form-control" id="transactionSelected" disabled>
                    <option *ngFor="let item of transactions" [value]="item.id">{{ item.description }} </option>
                  </select>
                </div>
                <div class="form-group col-lg-8">
                  <label>Tipo Comprobante y serie <span class="required"></span></label>
                  <div class="input-group">
                    <select class="form-control" id="typeVoucherSelected" [(ngModel)]="movement.typevoucher_id"
                      [ngModelOptions]="{standalone: true}" (change)="changeTypeVoucher()">
                      <option *ngFor="let item of typevouchers" [value]="item.id">{{ item.description }} </option>
                    </select>
                    <span class="input-group-prepend">
                      <span class="input-group-text">SERIE</span>
                    </span>
                    <span class="input-group-prepend">
                      <select class="form-control" id="serieSelected" [(ngModel)]="movement.serie"
                        [ngModelOptions]="{standalone: true}">
                        <option *ngFor="let item of series" [value]="item.series">{{ item.series }} </option>
                      </select>
                    </span>
                  </div>
                </div>

                <div class="form-group col-lg-12">
                  <label>Seleccionar cliente <span class="required"></span>
                    <ng-container *ngIf="movement.typevoucher_id != typevoucher_factura.id ">
                      <div class="float-right" style="margin-bottom: -5px;">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" [(ngModel)]="client_default"
                            [ngModelOptions]="{standalone: true}" (change)="setClientDefault()" id="client_default">
                          <label class="custom-control-label p-t-3" for="client_default">Cliente
                            Varios</label>
                        </div>
                      </div>
                    </ng-container>
                  </label>
                  <ng-container *ngIf="!client_default">
                    <ng-container *ngIf="isClientSelected">
                      <div class="input-group">
                        <input type="text" class="form-control form-control-sm" disabled
                          value="{{clientSelected.fullname}}">
                        <div class="input-group-append bg-custom b-0 removeClient">
                          <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                            (click)="removeClient()">
                            <i class="fas fa-backspace w-100 f-s-12"></i>
                          </div>
                          <div class="input-group-text bg-info w-100 text-center text-white pointer p-l-10"
                            data-toggle="modal" data-target="#openExtendsClient"
                            (click)="ClientExtendsComponent.editClient(clientSelected.id)">
                            <i class="far fas fa-pen-alt w-100 f-s-12"></i>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!isClientSelected">
                      <div class="input-group input-group-grid">
                        <component-search-client [classSize]="'search-small'"
                          (selectedClientEvent)="selectedClientSearch($event)" class="w-100">
                        </component-search-client>
                        <div class="input-group-append b-0">
                          <div class="input-group-text w-100 text-center pointer p-l-10" data-toggle="modal"
                            data-target="#openExtendsClient" (click)="ClientExtendsComponent.loadData()">
                            <i class="fas fa-user-plus w-100"></i>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="client_default">
                    <input type="text" class="form-control form-control-sm" disabled
                      value="{{clientSelected.fullname}}">
                  </ng-container>
                </div>
                <ng-container *ngIf="isClientSelected">
                  <div class="form-group col-lg-4">
                    <label> Documento<div class="book__nrodoc m-l-5"> ( {{clientSelected.typeDocument}} )</div>
                    </label>
                    <input type="text" class="form-control" value="{{clientSelected.document}}" disabled>
                  </div>
                  <div class="form-group col-lg-8">
                    <label>Dirección <span class="required"></span> </label>
                    <input type="text" class="form-control f-s-11" value="{{clientSelected.address}}" disabled>
                  </div>
                </ng-container>

                <div class="col-lg-12" x-show="transaction_cash == typetransaction_id">
                  <div class="row">
                    <div class="form-group col-lg-4">
                      <label>Método de pago</label>
                      <select class="form-control" id="paymentMethodSelected" [(ngModel)]="movement.paymentmethod_id"
                        [ngModelOptions]="{standalone: true}" (change)="changePaymentMethod()">
                        <option *ngFor="let item of paymentmethods" [value]="item.id">{{ item.description }}</option>
                      </select>
                    </div>
                    <ng-container *ngIf="paymentmethods.length > 0">
                      <ng-container *ngIf="paymentMethodSelected.associate_bank">
                        <div class="form-group col-lg-4">
                          <label>Cuenta destino
                            <span class="f-s-9" *ngIf="accountbanks.length == 0">( 0 registros )</span>
                          </label>
                          <ng-container *ngIf="accountbanks.length == 0">
                            <a type="button" class="btn btn-outline-info text-white"
                              routerLink="/{{branchofficeSlug}}/finanzas/cuentas_bancarias/lista">
                              <i class="fas fa-arrow-right m-r-5"></i>Agregar Cuenta
                            </a>
                          </ng-container>
                          <ng-container *ngIf="accountbanks.length > 0">
                            <select class="form-control" id="bankAccountSelected"
                              (change)="changeBankAccount($event.target)">
                              <option *ngIf="!isEdit" value="null">Seleccionar cuenta</option>
                              <option *ngFor="let item of accountbanks" [value]="item.id">{{ item.concat_description}}
                              </option>
                            </select>
                          </ng-container>
                        </div>
                        <div class="form-group col-lg-4">
                          <label>N° operación</label>
                          <input type="text" class="form-control" [(ngModel)]="movement.reference_operation"
                            [ngModelOptions]="{standalone: true}">
                        </div>
                      </ng-container>

                    </ng-container>
                  </div>
                </div>
                <!-- <div class="col-lg-12" x-show="transaction_credit == typetransaction_id">
                  <div class="row">
                    <div class="form-group col-lg-4">
                      <label>N° de cuotas <span class="required"></span></label>
                      <input type="text" class="form-control" :required="typetransaction_id == transaction_credit"
                        id="number_quota" wire:model.defer="schedule.number_quota" onclick="click_input_price(this)"
                        onkeyup="AllowOnlyNumbers(event, this)">
                      @error("schedule.number_quota")<small class="form-text text-danger">{{$message}}</small>@enderror
                    </div>
                    <div class="form-group col-lg-4">
                      <label>
                        <span data-toggle="tooltip" data-placement="right"
                          data-original-title="A partir de la fecha seleccionada se va generar su cronograma de pagos"
                          title="">
                          <i class="fas fa-info-circle m-r-5"></i>
                        </span>
                        Fecha N° 1 pago<span class="required"></span></label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="far fa-calendar-alt"></i>
                          </span>
                        </div>
                        <input type="text" id="first_date_schedule" :required="typetransaction_id == transaction_credit"
                          wire:model.defer="schedule.first_date_schedule" placeholder="Selecciona fecha"
                          ng-required="true" class="form-control">
                        @error("schedule.first_date_schedule")<small
                          class="form-text text-danger">{{$message}}</small>@enderror
                      </div>
                    </div>
                    <div class="form-group col-lg-4">
                      <label>Intervalo pagos <span class="required"></span></label>
                      <select class="form-control" id="intervalDateSelected"
                        x-on:change="@this.changeCreditdateIntervals($event.target.value)"
                        wire:model.defer="schedule.creditdateinterval_id">
                        @foreach($creditdateintervals as $interval)
                        <option value="{{$interval['id']}}">
                          {{$interval['description']}}</option>
                        @endforeach
                      </select>
                      @error("schedule.creditdateinterval_id")<small
                        class="form-text text-danger">{{$message}}</small>@enderror
                    </div>
                  </div>
                </div> -->

                <div class="form-group col-lg-12">
                  <div class="row">
                    <div class="form-group col-lg-4">
                      <label>Origen venta<span class="required"></span></label>
                      <select class="form-control" formControlName="origin_id" (change)="changeOriginSale()">
                        <option *ngFor="let item of originsales" [value]="item.id">{{ item.description }}</option>
                      </select>
                    </div>
                    <div class="form-group col-lg-4" *ngIf="item.value.origin_id == originsale_virtual">
                      <label>Canal virtual</label>
                      <select class="form-control" id="channelSaleSelected" formControlName="channel_id">
                        <option *ngFor="let item of virtualchannels" [value]="item.id">{{ item.description }}</option>
                      </select>
                    </div>
                    <div class="form-group col-lg-4">
                      <label><i class="fas fa-info-circle m-r-3"></i>Glosa C.</label>
                      <input type="text" class="form-control" disabled>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12" x-show="transaction_cash == typetransaction_id">
                  <div class="row">
                    <div class="form-group col-lg-4">
                      <label>TOTAL A PAGAR</label>
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <span class="input-group-text">{{toolsService.momeySol()}}</span>
                        </span>
                        <input type="text" class="form-control bold f-s-14" value="{{total_sale}}" disabled="true">
                      </div>
                    </div>
                    <div class="form-group col-lg-4">
                      <label>MONTO RECIBIDO</label>
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <span class="input-group-text">{{toolsService.momeySol()}}</span>
                        </span>
                        <input type="text" id="total_received" (keyup)="recalculateDifferenceMoney($event.target)"
                          numeric decimals="2" onclick="click_input(this)" class="form-control bold f-s-14">
                      </div>
                    </div>
                    <div class="form-group col-lg-4">
                      <label class="text-center">VUELTO</label>
                      <div>
                        <p class="f-s-16 text-primary text-center m-t-4 m-b-0 light">
                          {{toolsService.momeySol()}} {{total_change}}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 m-t-20 boxButtonsPaid">
                  <div class="flex flex-100 p-0">
                    <div class="flex flex-60 p-t-0 p-b-0 p-r-10">
                      <button type="button" class="btn btn-outline-danger btn-lg flex-30 m-r-10" (click)="cleanSale()">
                        Cancelar
                      </button>
                      <button type="button" class="btn btn-secondary btn-lg flex-70" (click)="changeToProduct()">
                        <i class="fas fa-arrow-left m-r-5"></i>Agregar más productos
                      </button>
                    </div>
                    <div class="flex-40">
                      <button type="submit" class="btn btn-primary btn-lg flex-100" [disabled]="total_sale==0"
                        (click)="savePaid()">
                        CONFIRMAR PAGO <i class="fas fa-check m-l-5"></i>
                      </button>
                    </div>
                    <!-- <div class="flex-40" x-show="transaction_credit == typetransaction_id">
                      <button type="submit" class="btn btn-warning btn-lg flex-100" wire:loading.attr="disabled"
                        wire:target="updateUnitSelectedDetail, updateQuantityDetail, updatePriceDetail"
                        :disabled="total_sale == 0">
                        CONFIRMAR CRÉDITO <i class="fas fa-check m-l-5"></i>
                      </button>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>

<app-client-extends (onSubmitEvent)="extendsClient($event)"></app-client-extends>
<app-product-priceunits-extends></app-product-priceunits-extends>
<app-product-informationdetail-extends></app-product-informationdetail-extends>
<app-hotelbookings-extends (onSubmitEvent)="extendsHotelBookings($event)"></app-hotelbookings-extends>
